/**
 * Creates a validated object with keys & values as specified by the given mapping
 * and optional custom validators as will be set by the analytics provider.
 * @param {object} params
 * @param {object} params.eventData mapped data with values and optional validators e.g.
 * `{
 *  name: 'New Field Name,
 *  value: 'some field value,
 *  validator: (value) => value.length < 50 // (optional)
 * }`
 * @returns {object} with only valid values with keys as specified in the mapping e.g.
 * `{
 *  'New Field Name': 'some field value'
 * }`
 */
export const getValidatedEventData = ({ eventData }) => {
    const validatedEventData = validateEventData(eventData);

    return createStructuredEventData(validatedEventData);
};

const validateEventData = (eventData) => {
    return eventData.filter((data) => {
        const { value, validator } = data;

        if (validator) {
            return validator(value);
        }

        return isValidValue(value);
    });
};

const isValidValue = (value) => value != null && value !== '';

const createStructuredEventData = (eventData) => {
    const structuredEventData = {};

    // ensure property labels are set from provided mapping e.g. 'accountName' => 'Account Name'
    eventData.forEach((data) => structuredEventData[data.name] = data.value);

    return structuredEventData;
};
